(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wi-announcement-bar"] && !Shopify.designMode) return;
  try {
    
class WIAnnouncement extends HTMLElement {
  connectedCallback() {
    if (this.dataset.scrolling !== 'true') return;
    this.group = this.querySelector('.wi-announcement__group');
    if (!this.group) return;

    this.observer = new ResizeObserver(() => this.update());
    this.observer.observe(this.group);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  update() {
    const width = this.group.getBoundingClientRect().width;
    const speed = Number(this.dataset.speed) || 35;
    if (!width) return;
    const duration = Math.max(8, Math.round(width / speed));
    if (duration === this.duration) return;
    this.duration = duration;
    this.style.setProperty('--wi-announcement-duration', duration + 's');
  }
}

if (!customElements.get('wi-announcement')) {
  customElements.define('wi-announcement', WIAnnouncement);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wi-related-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';

  if (customElements.get('wi-related-products')) return;

  class WIRelatedProducts extends HTMLElement {
    constructor() {
      super();

      this.handleSectionSelect = this.handleSectionSelect.bind(this);
      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerMove = this.handlePointerMove.bind(this);
      this.handlePointerUp = this.handlePointerUp.bind(this);
      this.handleClickCapture = this.handleClickCapture.bind(this);

      this.carousel = null;
      this.dragState = null;
      this.suppressClick = false;
    }

    connectedCallback() {
      if (this.dataset.wiReady === 'true') return;
      this.dataset.wiReady = 'true';

      this.addEventListener('shopify:section:select', this.handleSectionSelect);

      if (this.dataset.recommendationsReady === 'true') {
        this.setAttribute('aria-busy', 'false');
        this.setupCarousel();
        return;
      }

      if (window.Shopify?.designMode) {
        this.loadRecommendations();
        return;
      }

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer?.disconnect();
            this.loadRecommendations();
          },
          { rootMargin: '400px 0px' }
        );

        this.observer.observe(this);
      } else {
        this.loadRecommendations();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('shopify:section:select', this.handleSectionSelect);
      this.observer?.disconnect();
      this.controller?.abort();
      this.teardownCarousel();
    }

    handleSectionSelect() {
      if (this.dataset.recommendationsReady !== 'true') {
        this.loadRecommendations();
      } else {
        this.setupCarousel();
      }
    }

    setupCarousel() {
      const grid = this.querySelector(
        '.wi-related-products__grid:not(.wi-related-products__grid--loading)'
      );

      if (!grid || grid === this.carousel) return;

      this.teardownCarousel();
      this.carousel = grid;

      /*
        Touch devices use the browser's native momentum scrolling.
        Pointer handlers below are only for mouse/pen dragging so desktop
        previews and hybrid devices feel natural too.
      */
      grid.addEventListener('pointerdown', this.handlePointerDown);
      grid.addEventListener('pointermove', this.handlePointerMove, { passive: false });
      grid.addEventListener('pointerup', this.handlePointerUp);
      grid.addEventListener('pointercancel', this.handlePointerUp);
      grid.addEventListener('click', this.handleClickCapture, true);
    }

    teardownCarousel() {
      if (!this.carousel) return;

      this.carousel.removeEventListener('pointerdown', this.handlePointerDown);
      this.carousel.removeEventListener('pointermove', this.handlePointerMove);
      this.carousel.removeEventListener('pointerup', this.handlePointerUp);
      this.carousel.removeEventListener('pointercancel', this.handlePointerUp);
      this.carousel.removeEventListener('click', this.handleClickCapture, true);
      this.carousel.classList.remove('is-dragging');

      this.carousel = null;
      this.dragState = null;
      this.suppressClick = false;
    }

    handlePointerDown(event) {
      if (!this.carousel) return;
      if (event.pointerType === 'touch') return;
      if (event.button !== 0) return;

      /*
        Preserve normal interaction with variant selectors, quantity controls,
        add-to-cart buttons, etc. Product image/title links can still be dragged.
      */
      if (event.target.closest('button, input, select, textarea, label, summary')) return;

      this.dragState = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        startScrollLeft: this.carousel.scrollLeft,
        dragging: false
      };
    }

    handlePointerMove(event) {
      if (!this.carousel || !this.dragState) return;
      if (event.pointerId !== this.dragState.pointerId) return;

      const dx = event.clientX - this.dragState.startX;
      const dy = event.clientY - this.dragState.startY;

      if (!this.dragState.dragging) {
        /*
          Wait for a clear horizontal gesture before taking control.
          This avoids accidental drags from tiny pointer movements.
        */
        if (Math.abs(dx) < 5) return;
        if (Math.abs(dx) <= Math.abs(dy)) {
          this.dragState = null;
          return;
        }

        this.dragState.dragging = true;
        this.carousel.classList.add('is-dragging');

        try {
          this.carousel.setPointerCapture(event.pointerId);
        } catch (_) {}
      }

      event.preventDefault();
      this.carousel.scrollLeft = this.dragState.startScrollLeft - dx;
    }

    handlePointerUp(event) {
      if (!this.carousel || !this.dragState) return;
      if (event.pointerId !== this.dragState.pointerId) return;

      const wasDragging = this.dragState.dragging;

      if (wasDragging) {
        try {
          if (this.carousel.hasPointerCapture(event.pointerId)) {
            this.carousel.releasePointerCapture(event.pointerId);
          }
        } catch (_) {}

        this.carousel.classList.remove('is-dragging');

        /*
          Re-enable snapping on the next frame. The browser then settles the
          nearest card naturally instead of jumping during the drag itself.
        */
        requestAnimationFrame(() => {
          if (!this.carousel) return;
          this.carousel.getBoundingClientRect();
        });

        this.suppressClick = true;
        setTimeout(() => {
          this.suppressClick = false;
        }, 0);
      }

      this.dragState = null;
    }

    handleClickCapture(event) {
      if (!this.suppressClick) return;

      event.preventDefault();
      event.stopPropagation();
      this.suppressClick = false;
    }

    async loadRecommendations() {
      if (this.dataset.loading === 'true') return;
      this.dataset.loading = 'true';

      this.controller?.abort();
      this.controller = new AbortController();

      try {
        const response = await fetch(this.dataset.url, {
          credentials: 'same-origin',
          headers: {
            Accept: 'text/html',
            'X-Requested-With': 'XMLHttpRequest'
          },
          signal: this.controller.signal
        });

        if (!response.ok) {
          throw new Error(`Related products request failed (${response.status}).`);
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incoming = doc.querySelector('[data-wi-related-products-content]');
        const current = this.querySelector('[data-wi-related-products-content]');

        if (!incoming || !current) {
          throw new Error('Related products content is missing.');
        }

        const hasProducts = incoming.dataset.hasProducts === 'true';

        if (!hasProducts) {
          if (window.Shopify?.designMode) {
            const currentGrid = current.querySelector('.wi-related-products__grid');
            const emptyMessage = `<div class="wi-related-products__empty">${this.dataset.labelEmpty || 'Shopify returned no related products for this preview product.'}</div>`;

            if (currentGrid) {
              currentGrid.outerHTML = emptyMessage;
            } else {
              current.insertAdjacentHTML('beforeend', emptyMessage);
            }

            this.setAttribute('aria-busy', 'false');
          } else {
            this.hidden = true;
            this.style.display = 'none';
          }

          return;
        }

        /*
          The recommendations markup is replaced asynchronously, so the carousel
          handlers must be attached AFTER the new cards enter the DOM.
        */
        this.teardownCarousel();
        current.innerHTML = incoming.innerHTML;
        current.dataset.hasProducts = 'true';
        this.dataset.recommendationsReady = 'true';
        this.setAttribute('aria-busy', 'false');

        this.setupCarousel();

        this.dispatchEvent(
          new CustomEvent('recommendations:loaded', {
            bubbles: true,
            detail: { sectionId: this.dataset.sectionId }
          })
        );

        document.dispatchEvent(
          new CustomEvent('shopify:section:load', {
            bubbles: true,
            detail: { sectionId: this.dataset.sectionId }
          })
        );
      } catch (error) {
        if (error?.name === 'AbortError') return;

        console.warn('[WI Related Products] Unable to load recommendations.', error);

        if (window.Shopify?.designMode) {
          const current = this.querySelector('[data-wi-related-products-content]');

          if (current) {
            const currentGrid = current.querySelector('.wi-related-products__grid');
            const errorMessage = `<div class="wi-related-products__empty">${this.dataset.labelError || 'Related products could not be loaded in the editor preview.'}</div>`;

            if (currentGrid) {
              currentGrid.outerHTML = errorMessage;
            } else {
              current.insertAdjacentHTML('beforeend', errorMessage);
            }
          }

          this.setAttribute('aria-busy', 'false');
        } else {
          this.hidden = true;
          this.style.display = 'none';
        }
      } finally {
        delete this.dataset.loading;
      }
    }
  }

  customElements.define('wi-related-products', WIRelatedProducts);
})();

  } catch(e) { console.error(e); }
})();
})();
